export default __webpack_public_path__ + "static/media/Lucida Calligraphy Italic.3133153e.ttf";